const Constantes = {
    RUTA_API_PRODUCTO: "https://www.ikhor-coding.com/producto",
};
export default Constantes;